import { render, staticRenderFns } from "./OrdersList.vue?vue&type=template&id=4ef17bd2"
import script from "./OrdersList.vue?vue&type=script&lang=js"
export * from "./OrdersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports